import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'components/atoms/button'
import { ConfirmationModal } from 'components/organisms/modals/confirmation-modal'

interface DeleteAccountModalProps {
	open: boolean
	setOpen: (open: boolean) => void
	onConfirm: () => void
	loading?: boolean
}

export function DeleteAccountModal({ open, setOpen, onConfirm, loading = false }: DeleteAccountModalProps) {
	const handleConfirm = () => {
		onConfirm()
	}

	const handleCancel = () => {
		setOpen(false)
	}

	return (
		<ConfirmationModal title="Delete account" open={open} setOpen={setOpen}>
			<div>
				<div className="mb-8">We are sorry to see you go. Are you sure you want to delete your account?</div>
				<div className="space-y-2">
					<Button
						variant="secondary"
						onClick={handleConfirm}
						disabled={loading}
						className="flex items-center gap-1"
					>
						{loading && <FontAwesomeIcon icon={['fas', 'spinner']} size="lg" spin />}
						Yes
					</Button>
					<Button variant="primary" onClick={handleCancel} disabled={loading}>
						Cancel
					</Button>
				</div>
			</div>
		</ConfirmationModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface DeleteAccountModalManagedProps {
	onConfirm: () => void
	loading?: boolean
}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'delete-account': DeleteAccountModalManagedProps
	}
}

export function ManagedDeleteAccountModal({
	onClose,
	onConfirm,
	...rest
}: DeleteAccountModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<DeleteAccountModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
			onConfirm={() => { onConfirm(); handleClose() }}
			{...rest}
		/>
	)
}
